import {createAsyncThunk} from '@reduxjs/toolkit'
import {extractBranchData, extractTopODPairsData, extractMyCarrierData} from './ff-opsdash.utils'
import {getBranchActivity, getMyAllotment, getMyCarriers, getMyShipments} from 'services/ff-opsDashboard.service'
import {getSpecialdeals} from 'services/specialdeals.service'
import {get as _get} from 'lodash'
import genericspecial from 'assets/images/generic-special-deal.svg'

export const getspecialDealsAction = createAsyncThunk('getDeals', async (payload: any, {dispatch, rejectWithValue}) => {
    try {
        const {data} = await getSpecialdeals(payload)

        if (data?.successFlag) {
            data.response.forEach((deal) => {
                if (_get(deal, 'imagePath', '') === '' || _get(deal, 'imagePath', '') === null) {
                    deal.imagePath = genericspecial
                }
            })
            return data.response
        } else {
            return rejectWithValue({
                error: {text: 'Data unavailable.'}
            })
        }
    } catch (err: any) {
        return rejectWithValue({
            error: {
                text: 'Data unavailable.',
                code: '500'
            }
        })
    }
})

export const getBranchActivityAction = createAsyncThunk(
    'getBranchActivityAction',
    async (payload: string, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await getBranchActivity({branchId: payload})

            if (data?.successFlag) {
                const {totalBookingCount, branchActivityData, startDate, endDate, topCarriersData, maxTotalBooking} =
                    extractBranchData(data?.response?.branchActivities)

                const topOdPairsResponse = extractTopODPairsData(data?.response?.topODCarriers)

                const accountNumberMapResponse = data?.response?.accountNumberMap

                return {
                    branchActivityResponse: {
                        totalBookingCount,
                        maxTotalBooking,
                        branchActivityData
                    },
                    topCarriersResponse: {
                        startDate,
                        endDate,
                        topCarriersData
                    },
                    accountNumberMapResponse,
                    topOdPairsResponse
                }
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const fetchAllotment = createAsyncThunk('allotments', async (payload: any, {rejectWithValue}) => {
    try {
        const {data} = await getMyAllotment(payload)

        if (data?.successFlag) {
            const arr: any = []
            data.response.map((data) => data['ECIDAP-OUT']?.DETAIL?.map((item) => arr.push(item?.ENTRY)))
            if (arr.length === 0) {
                return rejectWithValue({
                    error: {
                        text: 'No bookings yet.',
                        booking: true
                    }
                })
            } else {
                return arr.slice(0, 5)
            }
        } else {
            return rejectWithValue({
                error: {text: 'Data unavailable.'}
            })
        }
    } catch (err: any) {
        return rejectWithValue({
            error: {
                text: 'Data unavailable.',
                code: '500'
            }
        })
    }
})

export const fetchMyCarriers = createAsyncThunk('fetchMyCarriers', async (payload: string, {rejectWithValue}) => {
    try {
        const request = {
            branchId: payload
        }
        const {data} = await getMyCarriers(request)
        if (data?.successFlag) {
            const myCarrierResponse = extractMyCarrierData(data.response)
            return myCarrierResponse
        } else {
            return rejectWithValue({
                error: {text: 'Data unavailable.'}
            })
        }
    } catch (err: any) {
        return rejectWithValue({
            error: {
                text: 'Data unavailable.',
                code: '500'
            }
        })
    }
})

export const getMyShipmentsAction = createAsyncThunk(
    'getMyShipmentsAction',
    async (payload: Record<string, any>, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await getMyShipments(payload)
            if (data?.successFlag) {
                const arr: any = []
                data?.response.map((data) => data.DETAILS.DETAIL.map((item) => arr.push(item)))
                if (arr?.length === 0) {
                    return rejectWithValue({
                        error: {
                            text: 'No bookings yet.',
                            booking: true
                        }
                    })
                } else {
                    return arr.slice(0, 5).map((row) => {
                        const carrier = row?.['AWB-INFO']?.ROUTING?.DEST?.CARRIER || '- -'
                        const awbNum = row?.['AWB-INFO']?.AWB?.replace(/(\d{3})(\d+)/, '$1-$2') || '- -'
                        const origin = row?.['AWB-INFO']?.ROUTING?.ORIGIN?.STATION || '- -'
                        const destination = row?.['AWB-INFO']?.ROUTING?.DEST?.STATION || '- -'
                        const status = row?.HISTORY?.ENTRY?.[0]?.STATUS?.CD || '- -'
                        const result = {
                            carrier,
                            awbNum,
                            origin,
                            destination,
                            status
                        }
                        return result
                    })
                }
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)
